export default {
  basicInfo: 'Basic Info',
  departments: 'Departments',
  campus: 'Campus',
  selectCampus: 'Select Campus',
  selectProviderCompany: 'Select Provider Company',
  dateFormat: 'Date Format',
  company: 'Company',
  status: 'Status',
  campuses: 'Campuses',
  providerCompany: 'Provider Company',
  routes: 'Routes',
  users: 'Users',
  registeredUsers: 'Registered Users',
  shuttleUsers: 'flexiShuttle Users ',
  poolcarUsers: 'flexiCar Users',
  rideUsers: 'flexiRide Users',
  parkUsers: 'flexiPark Users',
  region: 'Region',
  locations: 'Locations',
  locationName: 'Location Name',
  address: 'Address',
  serviceProvider: 'Service Provider',
  newServiceProvider: 'New Service Provider',
  addNewServiceProvider: 'Add New Service Provider',
  updateServiceProvider: 'Update Service Provider',
  admins: 'Admins',
  general: 'General',
  poolCarRide: 'flexiCar/flexiRide Private/ flexiRideShared',
  flexiCarTab: 'flexiCar',
  flexiRidePrivateTab: 'flexiRide',
  onDemandTab: 'On Demand',
  onDemand2Tab: 'On Demand 2',
  onDemand3Tab: 'On Demand 3',
  parking: 'flexiPark',
  allowance: 'Allowance',
  subCompanies: 'Sub Companies',
  pricing: 'Pricing',
  settings: 'Settings',
  noSubCompany: 'Subcompany not found.',
  newCampus: 'New Campus',
  newRegion: 'New Region',
  newLocation: 'New Location',
  newAdmin: 'New Admin',
  campusName: 'Campus Name',
  addNewCampus: 'Add New Campus',
  regionName: 'Region Name',
  addNewRegion: 'Add New Region',
  location: 'Location',
  editCampus: 'Edit Campus',
  editRegion: 'Edit Region',
  deleteCampus: 'Delete Campus',
  noLocation: 'No location founded.',
  deleteRegion: 'Delete Region',
  system: 'System',
  systemAdmin: 'System Admin',
  serviceProviderAdmin: 'Service Provider Admin',
  newDepartment: 'New Department',
  addNewDepartment: 'Add New Department',
  departmentName: 'Department Name',
  departmentNumber: 'Department Number',
  noDepartmentsAdded: 'No departments added yet',
  editDepartment: 'Edit Department',
  number: 'Number',
  phoneNumber: 'Phone Number',
  drawCampusLocation: 'Draw a polygon on the map to define the campus location.',
  editCampusArea: 'Drag polygon points to edit the campus area.',
  drawRegionLocation: 'Draw a polygon on the map to define the region location.',
  editRegionArea: 'Drag polygon points to edit the region area.',
  importKmlKmz: 'Import from KMZ/KML',
  importNoPolygon: 'No polygon could be found in the selected file.',
  importReadError: 'The file could not be read. Please select a valid KMZ/KML file.',
  campusesDeleted: 'Campuses which have registered riders and/or active route groups on them cannot be deleted',
  industries: {
    IT: 'IT',
    Education: 'Education',
    'Sales&CRM': 'Sales&CRM',
    Finance: 'Finance',
    'Design and Creative': 'Design and Creative',
    Marketing: 'Marketing',
    Operations: 'Operations',
    Construction: 'Construction',
    'HR & Recruiting': 'HR & Recruiting',
    'Software Development': 'Software Development',
    Legal: 'Legal',
    Other: 'Other',
  },
  basicInfoSubProps: {
    type: 'Type',
    companyName: 'Company Name',
    taxNumber: 'Tax Number',
    industry: 'Industry',
    language: 'Language',
    currency: 'Currency',
    unit: 'Unit',
    functionality: 'Functionality',
  },
  functionalities: {
    usingPoolcar: 'flexiCar',
    usingRide: 'flexiRide',
    usingShuttle: 'flexiShuttle',
    usingTaxi: 'flexiMileage',
    usingVanPool: 'flexiVanpool',
    usingCarPool: 'flexiCarpool',
    seeCommuteOptions: 'Commute Options',
    usingSharedRide: 'flexiRide Shared',
    feedback: 'Feedback',
    usingFlexiPark: 'flexiPark',
    usingSharedRide2: 'flexiRide Shared 2',
    usingSharedRide3: 'flexiRide Shared 3',
    usingCampusBike: 'Campus Bike',
    usingGuaranteedRideHome: 'Guaranteed Ride Home',
    publicLink: 'Public Link',
  },
  publicLinkText: {
    publicLinkControl: 'Public Link Control',
    publicLink: 'Public link',
    showDriverInfo: 'Show driver information on the public link.',
    showDriverPhone: 'Show driver phone number on the public link.',
    showVehicleInfo: 'Show vehicle information on the public link.',
    showVehicleInfoAs: 'Show the vehicle information in the public link according to',
    licensePlate: 'License Plate',
    vehicleId: 'Vehicle ID',
  },
  feedback: {
    userFeedbackCategoriesAndTopics: 'User Feedback Categories and Topics',
    noTopicsAdded: 'No topics added',
    text1:
      'You can select or deselect from the basic topic list provided for each category and optionally add custom topics. We advise you not to provide more than 10 topics for ease of use and clarity for users on the mobile app.',
    newTopic: 'New Topic',
    walkingDistance: 'Walking Distance',
    arrivedLate: 'Arrived Late',
    leftEarly: 'Left Early',
    noShow: 'No Show',
    driverBehavior: 'Driver Behavior',
    vehicleCleanliness: 'Vehicle Cleanliness',
    missingEquipment: 'Missing Equipment',
    checkinScan: 'Check-In Scan',
    other: 'Other',
    newFeedback: 'New Feedback',
    feedbackDetail: 'Feedback Detail',
    anyFeedbackMessage: 'You haven’t sent any feedback messages yet.',
    pleaseSelectDate: "Please indicate the date of the incident, if applicable. If not, leave today's date.",
    shareYourFeedback: 'Please share your feedback with us…',
    noMessage: 'No Messages',
  },
  generalText: {
    newUser: 'Send welcome e-mail when a new user is added.',
    emails: 'Send push, text message and e-mail notifications to users.',
    sendUsersEmail: 'Send users introduction e-mails after registration.',
    uniqueId: 'Require users to enter their Unique ID during onboarding.',
    phoneNumberRequired: 'Require a phone number during onboarding.',
    displaySurvey: 'Display survey on user onboarding.',
    checkPersonel: 'Check Dashboard Items by Personnel',
    dashboardShuttle: 'Shuttle',
    dashboardPoolcar: 'Poolcar',
    dashboardVanpool: 'Vanpool',
    dashboardTaxi: 'Taxi',
    dashboardRide: 'Flexiride',
    dashboardCalender: 'Calendar',
    dashboardPastUses: 'Past Uses',
    dashboardCarpool: 'Carpool',
    dashboardComplaints: 'Complaints',
    emailSignatureShowCompanyName: 'Show company name in email signature',
    mobileDashboardItems: 'Mobile Dashboard Items',
    request: 'Request',
    dashboardLoop: 'flexiLoop',
    firstLoginPickupReminder: 'Make it mandatory to save a preferred pick-up address during first login',
    changeHomeAddress: 'When the employees change their home addresses, email the administrators.',
    displayDriverInfoOnRiderApp: 'Display driver information on the rider app.',
    selectCompanyDepartment: 'Require users to select their company and department during onboarding.',
    sharedRideModuleName: 'Display the module name for the on-demand service as ',
    onboardingAccessibilityInfo: 'Collect information about riders’ accessibility needs during onboarding',
    additionalSeat: 'Additional Seat',
    autoAssignToWAVVehicle: 'Auto-assign to WAV Vehicle',
    newCategory: 'New Category',
    sharedRideModuleName2: 'Display the module name for the On Demand 2 service as',
    sharedRideModuleName3: 'Display the module name for the On Demand 3 service as',
  },
  adminsText: {
    setTwoFactor: 'Set two- factor authentication for admins.',
    adminsRequests: 'Admins to be informed about requests.',
    placeHolder: 'You can type multiple emails seperated by commas.',
  },
  poolCarRideText: {
    approvalFlexiCar: 'Require approval for flexiCar',
    shouldComplateDailyChecklist: 'Drivers should complete a daily checklist',
    reservationFlexiCar: 'Require reservation for flexiCar',
    approvalFlexiRide: 'Require approval for flexiRide',
    autoPlanning: 'Auto planning',
    sendConfirmationEmail: 'Send confirmation emails to EAs when the request is parsed from email',
    notifyRidersflexiRideRequest: 'Notify riders when driver and vehicle are assigned for their flexiRide request.',
    notifyRidersPickupPoint: 'Notify riders as the flexiRide vehicle arrives at the pick-up point',
    sendUsersSMSLink: 'Send users an SMS link to track the vehicle on trip times.',
    notifyDriverVehicleRequest: 'Notify assistants when driver and vehicle are assigned for their flexiRide request.',
    notifyflexiRideVehicleArrives: 'Notify assistants as the flexiRide vehicle arrives at the pick-up point',
    notifyflexiRideRequest: 'Notify assistants when the request is approved/rejected.',
    SendSMSLinkTrackVehicleTripTimes: 'Send assistants an SMS link to track the vehicle on trip times.',
    flexiRidePurposes: 'flexiRide Purposes',
    notifyApproachesPickupPoint:
      'Notify assistants {time} minutes before arrival as the flexiRide vehicle approaches the pick-up point.',
    notifyBeforeApproachesPickupPoint:
      'Notify assistants before arrival as the flexiRide vehicle approaches the pick-up point.',
    notifyRidersApproachesPickupPoint:
      'Notify riders {time} minutes  before arrival as the flexiRide vehicle approaches the pick-up point.',
    notifyRidersBeforeApproachesPickupPoint:
      'Notify riders before arrival as the flexiRide vehicle approaches the pick-up point.',
    notifyBeforeArrival: 'Notify assistants before arrival',
    notifyRidersBeforeArrival: 'Notify riders before arrival',
    purposeMustSelectedAdded: 'At least one purpose must be selected or added.',
    notifyRidersRequest: 'Notify riders when the request is approved/rejected.',
    notifyAdministratorsFlexiRideRequest: 'Notify administrators when a new flexiRide request is received.',
    riderForRequestAcknowledged: 'Notify riders when the flexiRide request is acknowledged by the administrator.',
    assistantForRequestAcknowledged:
      'Notify assistants when the flexiRide request is acknowledged by the administrator.',
    mobilityAssistance: 'Riders can request mobility assistance.',
    serviceTimeWithHoursMultiple: 'The service is available {0} on {1}.',
    requestsInAdvance: '{0} requests can be made at {mins} min intervals.',
    requestsInAdvanceLong: 'Request Time Windows',
    sharedServiceTime: 'Service time for each stop',
    singleRequest: 'The max. number of riders that can be selected for a single request',
    riders: 'riders',
    reservationsEarliest: 'Minimum advance reservation time',
    adaOptionForAdaStaffOnly: 'The ADA option is available to ADA staff only.',
    highDemandStopClassification: 'High-Demand Stop Classification',
    highDemandExceedsThreshold: 'A stop is classified as high-demand if its hourly ridership exceeds {count}',
    highDemandTopPercentage:
      'A stop is classified as high-demand if its hourly ridership falls within the top {percentage}% of stops by ridership',
    exceedsThreshold: 'Exceeds threshold',
    topPercentage: 'Top percentage',
    pickupOtpBuffer: 'The buffer for pick-up times to be considered for on-time performance tracking is',
    dropoffOtpBuffer: 'The buffer for drop-off times to be considered for on-time performance tracking is',
    avgDeviationWarningThreshold: 'Show warning on dashboard when Average Deviation exceeds',
    acceptanceRateWarningThreshold: 'Show warning on dashboard when Acceptance Rate falls below',
    ridersPerHourWarningThreshold: 'Show warning on dashboard when Riders per Hour falls below',
    pickupOtpWarningThreshold: 'Show warning on dashboard when Pick-up OTP falls below',
    dropoffOtpWarningThreshold: 'Show warning on dashboard when Drop-off OTP falls below',
    avgPickupDeviationWarningThreshold: 'Show warning on dashboard when Average Pick-up Deviation exceeds',
    avgDropoffDeviationWarningThreshold: 'Show warning on dashboard when Average Drop-off Deviation exceeds',
    serviceTimeWithHours: 'The service is available {0} on {1}.',
    serviceTimeWithoutHours: 'The service is available all day on {0}.',
    theActiveTimesForFlexiRideSharedService: 'The active times for {0} service',
    allDay: 'All day',
    duringSpecifiedHours: 'During specified hours',
    addPeriod: 'Add Period',
    phoneNumberRequiredFlexiRideSharedRequests: 'A phone number is required for all requests',
    theStartingTimeMustEarlierThanTheEndingTime: 'The starting time must be earlier than the ending time',
    from: 'from',
    to: 'to',
    weekdays: 'weekdays',
    runOptimizationBasedOn: {
      message: 'Run optimization based on',
      vehicleCount: 'Vehicle Count',
      maximumUtilization: 'Maximum utilization',
    },
    sharedRideCustomStop: 'Allow ride requests from and to any location',
    recurringRequest: 'Allow recurring ride requests',
    futureThresholdInMin: 'Future Request Threshold',
    futureThresholdInMinInfo:
      'Determines when future ride requests are planned. Requests within the threshold are planned immediately, while those beyond it are held for future planning.',
    additionalRidersEnabled: 'Allow requests for multiple riders',
  },
  requestStartTime: {
    earliestTime: 'Earliest a request can be made',
    theSameDay: 'The same day',
    inAdvance: 'In advance',
    day: 'day',
    days: 'days',
    hour: 'hour',
    hours: 'hours',
    daysInAdvanceCount: 'How many days in advance?',
    daysInAdvance: 'day(s) in advance',
    sameDay: 'same day',
    onTheDay: 'Requests can be made on the day of the trip',
    daysEarlier: {
      single: 'day in advance.',
      multiple: 'days in advance.',
    },
    requestsCanBeMade: 'Requests can be made is {0}',
    earliestBookingBeforeTrip: 'Earliest booking before trip',
    latestBookingBeforeTrip: 'Latest booking before trip',
    unit: 'Unit',
    dayUnit: 'Days',
    hourUnit: 'Hours',
    dayValue: 'Day value',
    hourValue: 'Hour value',
    pleaseEnterWholeNumber: 'Please enter a whole number.',
    minimumAdvanceBookingMustBeAtLeastOneHour: 'Minimum advance booking must be at least 1 hour.',
    earliestBookingMustBeGreaterThanLatest:
      'Invalid booking window: Earliest booking time frame must be greater than the latest.',
    bookingWindowInfo: {
      withLatest: 'Requests can be made earliest {earliest} and latest {latest} before the pickup time.',
      onlyEarliest: 'Requests can be made earliest {earliest} before the pickup time.',
      sameDay: 'Requests can be made the same day.',
      sameDayWithLatest: 'Requests can be made the same day and latest {latest} before the pickup time.',
    },
  },
  operationalHours: {
    title: 'The service hours for {serviceName}',
    servicePeriod: 'Service Period {number}',
    addServicePeriod: 'Add Service Period',
    deletePeriod: 'Delete Period',
    addHours: 'Add Hours',
    userProfile: 'User Profile',
    allUserProfiles: 'All user profiles',
    noUserProfilesDefined: 'No user profiles defined',
    defineUserProfilesFirst: 'Define user profiles first to restrict service access based on the profile.',
    userProfileRequired: 'Please select a user profile for each time interval.',
    dayRequired: 'Please select at least one day.',
    timeRequired: 'Please fill all time intervals.',
    overlapError: 'Time intervals cannot overlap. Please adjust the hours.',
    crossDayOverlapError: 'Time intervals cannot overlap with another service period. Please adjust the hours.',
    weekends: 'weekends',
    viewPrefix: 'The service operates {periods}.',
    viewPeriodHours: 'on {days} from {hours}',
    viewPeriodAllDay: 'on {days} all day',
  },
  flexiMileageText: {
    flexiMileageNotifications: 'flexiMileage Notifications',
    flexiMileagePurposes: 'flexiMileage Purposes',
    perMileCost: 'Per mile Cost',
    riderForComfirmed: 'Notify riders when their reported mileage is confirmed.',
    riderForRejected: 'Notify riders when their reported mileage is rejected.',
    riderForPaidBack: 'Notify riders when their reported mileage is paid back.',
  },
  shuttleText: {
    userControl: 'User Control',
    text1: 'Allow users to see shuttle routes to other campuses.',
    text2: 'Admin Notifications',
    text3: 'Report admins about vehicles not sending signal.',
    text4: 'Report admins about shuttle routes with late arrival or no arrival.',
    text5: 'Notify admins about card scan rates.',
    notifyAdminsWhenNewRouteCreatedByOptimization: 'Notify admins when a new route is created by route optimization.',
    cardScans: 'Card/QR Scans',
    cardScansInfo:
      'If the card/QR is not scanned for {scanDays} days, send users daily warning e-mails for {emailDays} days unless user restarts scanning.',
    text6:
      'If the card/QR is not scanned for {scanDays} day(s), send users daily warning e-mails for {emailDays} day(s) unless user restarts scanning.',
    cardQrNotScannedLimitBeforeWarning: 'Card/QR not scanned day limit',
    warningCountBeforeTreatment: 'Warning email day count',
    text7: 'Set user passive for flexiShuttle if the card/QR is not scanned for  {flexiShuttleDays} days.',
    rules: 'Rules',
    text8: 'Send routes to the driver app.',
    serviceProviders: 'Service Providers',
    text9: 'Make rider list visible to service providers.',
    text10: 'Make campus based notification sending control available for service providers.',
    text11: 'vehicle plate',
    text12: 'route id',
    text13: 'Set QR codes according to {QrCodes}.',
    text14: 'Maximum age of shuttle busses should be {maxVehicleAgeAllowed} years.',
    maxVehicleAgeAllowed: 'Maximum vehicle age of shuttle busses',
    text15: 'Drivers can be called',
    text16: 'Require approval for vehicle and driver assignments made by the provider company.',
    text17: 'Require approval for when riders want to change their regular route.',
    text18: 'When sending daily routes to the drivers, include stops that do not have assigned riders.',
    skipStopsForNoShowRiders: 'Skip stops for no-show riders on near-demand routes.',
    recalculateRouteStopTimes: 'Recalculate route stop times, excluding non-reserved stops.',
    checkVehiclesCampusZone: 'Check if vehicles are in the Campus Zone between the instance time.',
    ridersCanReserveEvenThoughOverCapacity: 'Riders can reserve even though overcapacity,',
    blockDuplicateDemandPerDirection:
      'Allow riders to make only one inbound and one outbound Near Demand request per day, across all route groups.',
    shuttleBufferForArrivalTime:
      'The buffer for arrival times to be considered for on-time performance tracking is {shuttleBufferForArrivalTime}',
    applyThresholdToFirstStop:
      'Apply the arrival time buffer to the first stop of inbound routes.',
    shuttleBufferForDepartureTime:
      'The buffer for departure times to be considered for on-time performance tracking is {shuttleBufferForDepartureTime}',
    defaultCoverageRadius: 'The default coverage radius for stops is {defaultCoverageRadius}',
    updateExistingStop: 'Update existing stops with the new radius.',
    text19: 'Users can select number of riders while making dynamic route reqeusts',
    enableBikeReservations: 'Enable bike reservations',
    enableWheelchairReservations: 'Enable wheelchair reservations',
    text20: 'On the dispatch screen, include the OTP of all stops for loop routes in the total dashboard calculations.',
    text21: 'Notify administrators if a driver does not check-in for a task within the planned time.',
    setSuspensionRule: 'Set suspension rule based on rider behavior',
    repeatedNoShowEnabled: 'Repeated no-shows on dynamic shuttle routes',
    repeatedNoShowCount: 'Count of no-shows is at least',
    repeatedNoShowPeriod: 'Time period',
    repeatedNoShowAction: 'Action',
    repeatedNoShowActionEmail: 'Email the rider list to admins',
    repeatedNoShowActionSuspend: 'Automatically suspend from service',
    repeatedLateCancellationEnabled: 'Repeated late cancellations on dynamic shuttle routes',
    repeatedLateCancellationCount: 'Count of late cancellations is at least',
    suspendFor: 'Suspend for',
    repeatedNoShowThresholdLoweredWarning:
      'Lowering this threshold may cause some riders to be flagged or suspended who previously were not. Do you want to continue?',
    repeatedLateCancellationThresholdLoweredWarning:
      'Lowering this threshold may cause some riders to be flagged or suspended who previously were not. Do you want to continue?',
    checkSamsaraOnVehicleAdd: 'Check Samsara when adding vehicles',
    text22: 'Allow riders to search for routes to/from locations other than their preferred pickup point.',
    sendAllRoutes: 'Show the “All Routes” tab on the rider route search screen',
    isDefaultAllRoutes: 'Open the route search screen with “All Routes” selected by default',
    text23: 'APC Device Available',
    text24: 'Use APC for Passenger Counting',
    showVehicleInfoBy: {
      message: 'Show the vehicle information in the rider app according to',
      license: 'License Plate',
      vehicleId: 'Vehicle ID',
    },
    commuteTimeOptionsByRouteGroupSchedule:
      'Display commute time options based on the selected route groups’ schedules during rider app registration.',
    triggerGtfs: 'Trigger GTFS',
    updateExistingStopSuccess: 'Existing stops updated successfully',
    updateExistingStopError: 'Failed to update existing stops',
    userNotifications: 'User Notifications',
    approachingNotification: 'Approaching notification',
    arrivalNotification: 'Arrival notification',
    bulkMessages: 'Bulk/individual messages',
    announcements: 'Announcements',
    ticketReplies: 'Ticket replies',
    driverVehicleChanges: 'Driver & vehicle changes',
    newRouteCreated: 'New route created',
    routeInstanceCancelled: 'Route instance cancelled',
    routeInstanceCancellationReverted: 'Route instance cancellation reverted',
    reservationPorting: 'Reservation porting',
    noShow: 'No show',
    stopTimeChange: 'Stop time change',
    waitlist: 'Waitlist',
  },

  vanpoolText: {
    driverAndRiderAgeRequirements: {
      text1: 'Minimum age required for vanpool <strong>riders</strong>',
      minimumAgeForRiders: 'Minimum age for riders',
      text2: 'Riders must be over {age} years old',
      text3: 'Minimum age required for vanpool <strong>drivers</strong>',
      minimumAgeForDrivers: 'Minimum age for drivers',
      text4: 'Drivers must be over {age} years old',
    },
    driverLicenceRequirements: {
      text1: 'Minimum period of driver licence holdership required for vanpool <strong>drivers</strong>.',
      text2: 'Vanpool drivers must have held a valid US driver license for at least {age} years.',
    },
    adminNotifications: {
      text2: 'Report admins when the number of riders on a vanpool trip is below {riderCount}',
      text3: 'Report admins when the non-commute mile of a vanpool route is over {distanceRatio}',
      text6: 'Notify admins when the telematics device is disassembled from a vehicle.',
      text7: 'Notify admins when a rider sends a new vanpool request.',
    },
  },
  driverAndRiderAgeRequirements: 'Driver and Rider Age Requirements',
  driverLicenceRequirements: 'Driver Licence Requirements',
  adminNotifications: 'Admin Notifications',

  carpoolText: {
    unitPricePerMile: 'Unit price per mile.',
    matchUserType: 'Restrict carpool matching by user type',
    matchUserTypeInfo: 'When on, employees are matched only with employees of the same user type.',
  },
  adminsToBeNotified: 'Admins to be notified',
  notifyAdmins: 'Notify Admins',
  recipientAdminEmails: 'Recipient Admin Email(s)',
  clearSelection: 'Clear Selection',
  addNewCompany: 'Add New Company',
  addNewSubCompany: 'Add New Sub Company',
  mainCompany: 'Main Company',
  thirdParty: 'Third Party',
  companyName: 'Company Name',
  taxNumber: 'Tax Number',
  selectIndustry: 'Select Industry',
  selectCompany: 'Select Company',
  confirmMessage: 'Do you want to save the changes you made?',
  gtfsSuccessMessage: 'GTFS was successfully triggered.',
  deleteMessageText: 'Are you sure you want to continue?',
  continueMessage: 'Are you sure you want to continue?',
  noServiceProviderMessage: 'No service providers added yet.',
  noAdminAddedYet: 'No admins added yet.',
  noCampusesAddedYet: 'No campuses added yet.',
  noRegionsAddedYet: 'No regions added yet.',
  noServiceProvidersAddedYet: 'No service providers added yet.',
  noSubCompaniesDefinedYet: 'No sub companies defined yet.',
  confirmContinueMessage: 'Are you sure you want to continue?',
  flexiRideNotifications: 'flexiRide Notifications',
  corporateRiders: 'Corporate Riders',
  flexiRideAssitants: 'flexiRide Assistants',
  pushNotification: 'Push Notification',
  Sms: 'SMS',
  business: 'Business',
  personal: 'Personal',
  purposeDescription: 'Purpose description',
  estimatedServiceTime: 'Estimated Service Time',
  newPurpose: 'New Purpose',
  flexiRideAssistants: 'flexiRide Assistants',
  serviceProviders: 'Service Providers',
  companyDomainAddress: 'Company domain address',
  timeZone: 'Time Zone',
  flexiShuttleDocuments: 'flexiShuttle Documents',
  typeTopicTitle: 'Type topic title',
  dismissMessage: 'Are you sure you want to close the panel? Any unsaved changes will be lost.',
  openingPage: 'Opening Page',
  selectOpeningPage: 'Select an opening page',
  sendWelcomeEmail: 'Send Welcome Email',
  welcomeEmailWillBeSentToAdmin: 'A welcome email will be sent to {0}.',
  welcomeEmailSentToAdmin: 'Welcome email sent successfully.',
  cancelRequestMessage: 'Are you sure you want to delete your {2} reservation at {1} on {0}?',
  TBD: 'TBD',
  messageToBeDisplayedOnTheRiderApp: 'Message to be displayed on the rider app',
  pause: 'Pause',
  pausedBetween: 'Paused between',
  from: 'From',
  until: 'Until',
  reactivatePausedModuleMessage: 'This service is paused until {date}. Are you sure you want to activate it earlier?',
  moduleReactivatedSuccessfully: 'Module has been reactivated successfully.',
  userProfiles: 'User Profiles',
  userProfilesText: {
    organizationMember: 'Organization Member',
    guest: 'Guest',
    addUserType: 'Add User Type',
    userTypeName: 'Type Name',
    userTypeNamePlaceholder: 'e.g. Full Time',
    userTypeNameRequired: 'User type name is required.',
    moduleAccess: 'Module Access',
    deleteUserType: 'Delete',
    deleteUserTypeConfirm: 'Are you sure you want to delete this user type? This action cannot be undone.',
    noUserTypes: 'No user types defined yet.',
    savingUserType: 'Saving…',
    userTypeSaved: 'User type saved successfully.',
    userTypeDeleted: 'User type deleted successfully.',
    addUserTypeTitle: 'New User Type',
    cancel: 'Cancel',
    add: 'Add',
  },
};
